import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postCameraViolation = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/violations/camera`,
    data: payload,
  });

  return data?.data;
};

export default postCameraViolation;
